import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const LoginScreen = ({ handleSignIn }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
      }}
    >           
    
      {/* Left side - Image */}
      <Box
        sx={{
          flex: 1,
          backgroundImage: 'url(/images/logout_image.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      
      {/* Right side - Login form */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: '#f8f9fa',
          px: 4,
          py: 6,
          position: 'relative',
        }}
      >
        {/* Need help? button */}
        <Button
          variant="text"
          sx={{
            position: 'absolute',
            top: 20,
            right: 20,
            color: '#666',
            fontSize: 12,
            textTransform: 'none',
          }}
          startIcon={<Box component="img" src="/images/settings.svg" alt="" sx={{ width: 16, height: 16 }} />}
        >
          Need help?
        </Button>

        {/* Login content */}
        <Box sx={{ textAlign: 'center', maxWidth: 400 }}>
          {/* DCLI Logo */}
          <Box component="img" src="/images/group-1.svg" alt="DCLI" sx={{ height: 60, mb: 4 }} />
          
          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#333',
              mb: 1,
              fontSize: '20px',
            }}
          >
            Sign in to your account with
          </Typography>
          
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#333',
              mb: 4,
              fontSize: '20px',
            }}
          >
            Microsoft Entra ID
          </Typography>

          {/* Sign In Button */}
          <Button
            variant="contained"
            onClick={handleSignIn}
            sx={{
              bgcolor: '#d73527',
              color: 'white',
              fontSize: 14,
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: '4px',
              px: 3,
              py: 1.5,
              minWidth: 200,
              '&:hover': {
                bgcolor: '#c12e20',
              },
            }}
            startIcon={
              <Box component="img" src="/images/windows.svg" alt="" sx={{ width: 20, height: 19 }} />
            }
          >
            Sign In With Microsoft
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginScreen;
